module.exports = __webpack_public_path__ + "img/clickandbuy-logo.df20ebdc.svg";